// env INVESTIGATIONAL_ONLY
export const getInvestigationOnlyEnvFlag = () => {
  return __INVESTIGATIONAL_ONLY__
}

// env GOOGLE_OAUTH_CLIENT_ID
export const getGoogleClientID = () => {
  return __GOOGLE_OAUTH_CLIENT_ID__
}

export const getBuildNo = () => {
  return __BUILDNO__
}

export const getBuildTime = () => {
  return __BUILDTIME__
}

// env NODE_ENV=stagingEU & NODE_ENV=productionEU
export const getIsEU = () => {
  return __STAGINGEU__ || __PRODEU__
}

// env COGNITO_USER_POOL_ID
export const getUserPoolId = () => {
  return __COGNITO_USER_POOL_ID__
}

// env COGNITO_USER_POOL_ID
export const getClientId = () => {
  return __COGNITO_CLIENT_ID__
}

// env COGNITO_USER_POOL_ID
export const getSecretID = () => {
  return __COGNITO_SECRET_ID__
}

// env COGNITO_BASE_URL
export const getCognitoBaseUrl = () => {
  return __COGNITO_BASE_URL__
}

//env COGNITO_RESPONCSE_TYPE
export const getCognitoResponseType = () => {
  return __COGNITO_RESPONSE_TYPE__
}

//env COGNITO_SCOPE
export const getCognitoScope = () => {
  return __COGNITO_SCOPE__
}



// WEBPACK FOOTER //
// ./src/constants/envUtilities.js